import React from 'react';
import { Navigation } from '../../components/Navigation/navigation';
import { SignIn } from '@clerk/clerk-react';
import './signin.css';

const appearance = {
    layout: {
        socialButtonsPlacement: 'bottom',
        socialButtonsVariant: 'iconButton',
      },
    variables: {
        fontSize: '2vh'
    }
};

export const Signin = () => {
    return(
        <div>
            <Navigation showAddresses={false} showAuthButtons={false}/>
            <div className="sign-in-container">
                <SignIn appearance={appearance} />
            </div>
        </div>
    );
}